import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'
import { invocarFuncion } from '../lib/invocarFuncion'
import SuplementosPlan from './SuplementosPlan'
import './Sos.css'

export default function PlanLineamientos({ usuario }) {
  const [plan, setPlan] = useState(null)
  const [loading, setLoading] = useState(true)
  const [abriendoPdf, setAbriendoPdf] = useState(false)

  useEffect(() => { cargar() }, [])

  const cargar = async () => {
    setLoading(true)
    const { data } = await supabase.from('plan_paciente')
      .select('*').eq('usuario_id', usuario.id).eq('activo', true).maybeSingle()
    setPlan(data)
    setLoading(false)
  }

  // #14: mismo patrón que abrirContenido en Clases.js — el PDF vive en un
  // bucket privado, se pide una signed URL fresca recién al abrir.
  const verPdf = async () => {
    setAbriendoPdf(true)
    const { data, error } = await invocarFuncion('obtener-url-plan', { body: { plan_paciente_id: plan.id } })
    setAbriendoPdf(false)
    if (error || !data?.url) { alert('No se pudo abrir el PDF. Probá de nuevo.'); return }
    window.open(data.url, '_blank', 'noopener,noreferrer')
  }

  return (
    <div className="sos-page">
      <div className="page-header">
        <h1 className="page-titulo">📋 Plan o Lineamientos</h1>
        <p className="page-subtitulo">Los lineamientos que armó tu profesional para vos</p>
      </div>

      <div className="sos-contenido">
        {loading ? (
          <p className="sos-vacio">Cargando...</p>
        ) : !plan ? (
          <div className="empty-state">
            <div className="empty-icon">📋</div>
            <p>Todavía no tenés un plan asignado. Tu profesional lo va a cargar pronto.</p>
          </div>
        ) : (
          <div className="sos-card">
            <p className="sos-card-frase" style={{ whiteSpace: 'pre-wrap', fontStyle: 'normal' }}>{plan.contenido}</p>
            {plan.archivo_url && (
              <button className="btn-primario" style={{ width: '100%', marginTop: 14 }} onClick={verPdf} disabled={abriendoPdf}>
                {abriendoPdf ? 'Abriendo...' : '📄 Ver PDF del plan'}
              </button>
            )}
          </div>
        )}

        <SuplementosPlan usuario={usuario} />
      </div>
    </div>
  )
}
